export default __webpack_public_path__ + "static/media/Md.shehabuddin-tushar.d1d0e91a.pdf";